import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'SageCore',
  brandName: 'SageCore',
  description: 'Sistema de agendamento para consultores',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Reunião de consultoria',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Consultor explicando gráfico',
  },
  testimonials: [
    {
      name: 'Fernando Lima',
      role: 'Consultor Financeiro',
      text: 'O SageCore é essencial para gerir as minhas sessões com clientes. A integração com o calendário é perfeita.',
      image: testimonial1,
    },
    {
      name: 'Helena Costa',
      role: 'Consultora de Marketing',
      text: 'A facilidade com que os meus clientes marcam as consultorias libertou-me tempo para focar na estratégia.',
      image: testimonial2,
    },
    {
      name: 'Vasco Reis',
      role: 'CEO, Reis Consulting',
      text: 'Uma ferramenta robusta e fiável. A nossa produtividade aumentou e os clientes estão mais satisfeitos.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'consultor',
    professionals: 'consultores',
    business: 'consultoria',
    businesses: 'consultorias',
    service: 'sessão',
    services: 'sessões',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'reunião',
    appointments: 'reuniões',
  },
  homepage: {
    hero: {
      badge: 'Solução Estratégica',
      title: 'Potencialize sua consultoria com SageCore',
      description: 'Otimize a gestão dos seus clientes e maximize o impacto das suas consultorias estratégicas.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup profissional', 'Integração completa'],
    },
    statistics: [
      { value: '180+', label: 'Consultorias' },
      { value: '16k+', label: 'Sessões' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Gestão Manual de Clientes',
        description: 'Controlar projetos e sessões em planilhas gera desorganização e compromete resultados.',
        icon: 'Users',
        quote: {
          text: 'Antes do SageCore perdia 3 horas semanais apenas organizando agendas de diferentes clientes',
          author: 'Dr. Miguel Pereira',
          business: 'Pereira Consulting',
        },
      },
      {
        title: 'Comunicação Ineficiente',
        description: 'Trocas de emails constantes para marcar sessões reduzem o tempo dedicado à estratégia.',
        icon: 'MessageSquare',
        stats: [
          { label: 'Emails diários para agendamento:', value: '15+' },
          { label: 'Tempo perdido por semana:', value: '4 horas' },
        ],
      },
      {
        title: 'Acompanhamento de Projetos',
        description: 'Sem registos adequados, é difícil acompanhar o progresso e resultados das consultorias.',
        icon: 'TrendingUp',
        quote: {
          text: 'O histórico de sessões me permite oferecer consultorias cada vez mais personalizadas',
          author: 'Ana Rodrigues',
          business: 'Stratégic Solutions',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'SageCore: Intelligence estratégica aplicada',
      description: 'Uma plataforma completa para consultores que querem maximizar seu impacto e eficiência.',
      features: [
        {
          title: 'Agendamento Inteligente',
          description: 'Clientes marcam sessões respeitando sua disponibilidade e especialidade.',
        },
        {
          title: 'Dashboard de Projetos',
          description: 'Acompanhe o progresso e resultados de cada cliente em tempo real.',
        },
        {
          title: 'Relatórios Estratégicos',
          description: 'Dados e insights para otimizar suas consultorias e fidelizar clientes.',
        },
      ],
    },
    testimonials: {
      title: 'O que os consultores dizem',
      description: 'Profissionais que escolheram o SageCore para elevar suas consultorias.',
    },
    finalCta: {
      title: 'Pronto para potencializar sua consultoria?',
      description: 'Junte-se aos consultores que já maximizaram seus resultados com o SageCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Conversar com Especialista',
    },
    contact: {
      title: 'Contacte-nos',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de consultor',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
